import React from 'react';
import {connect} from "react-redux";

import {CardContainer, Input, Button, Validator, Notification, Loading} from 'components/common/uiKit';

import {CourseApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';
import * as RouteService from 'services/route'


class CourseRegistration extends React.Component {
    constructor(props) {
        super(props);

        this.validator = Validator();

        this.state = {
            id: 0,
            courseId: 0,
            submitLoading: false,
            cardNumber: '',
            cardOwner: '',
            trackingCode: '',
            submitted: false,
            enabled: false,
            loading: true
        };
    }

    componentDidMount() {
        this.getQsData();
    }

    getQsData() {
        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.courseId) {
            Notification('error', 'WrongParams');

            const {history} = this.props;
            history.goBack();
        }

        this.setState({courseId: qs.courseId}, this.loadData);
    }

    loadData = () => {
        const {courseId} = this.state;

        CourseApi.GetOfflineRegistered(courseId)
            .then(res => {
                if (res.status == 204) {
                    this.setState({enabled: true});
                }
                if (res.status == 200) {
                    const {data} = res;
                    this.setState({
                        id: data.id,
                        cardOwner: data.ownerName,
                        trackingCode: data.trackingCode,
                        cardNumber: data.cardNumber,
                        enabled: false
                    });
                }

                this.setState({loading: false});
            });
    };

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    submit = () => {
        const {id, courseId, cardNumber, cardOwner, trackingCode} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.CourseRegistration;

        const validationResult = this.validator.fieldValid(pageTranslates.CardNumber) && this.validator.fieldValid(pageTranslates.CardOwner) && this.validator.fieldValid(pageTranslates.TrackingCode);
        if (validationResult) {
            this.setState({submitLoading: true});

            const data = {
                id: id,
                courseId: parseInt(courseId),
                cardNumber: parseInt(cardNumber),
                ownerName: cardOwner,
                trackingCode
            };

            CourseApi.OfflineRegister(data)
                .then(res => {
                    if (res && res.status == 200) {
                        this.setState({submitted: true});
                        Notification('success', 'Succeed')
                    }
                }).finally(x => {
                this.setState({submitLoading: false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
        }
    };

    render() {
        const {loading} = this.state;
        if (loading)
            return <Loading/>

        const {submitLoading, cardNumber, cardOwner, trackingCode, submitted, enabled} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.CourseRegistration;

        return (
            <CardContainer>
                <h3>
                    {pageTranslates.Title}
                </h3>
                <p>
                    {pageTranslates.Description}
                </p>

                <Input value={cardNumber} placeholder={pageTranslates.CardNumber} type='tel'
                       onChange={this.handleInputChange('cardNumber')} disabled={!enabled}/>
                {this.validator.message(pageTranslates.CardNumber, cardNumber, 'required|integer')}

                <Input value={cardOwner} placeholder={pageTranslates.CardOwner}
                       onChange={this.handleInputChange('cardOwner')} disabled={!enabled}/>
                {this.validator.message(pageTranslates.CardOwner, cardOwner, 'required|string')}

                <Input value={trackingCode} placeholder={pageTranslates.TrackingCode} type='tel'
                       onChange={this.handleInputChange('trackingCode')} disabled={!enabled}/>
                {this.validator.message(pageTranslates.TrackingCode, cardOwner, 'required|string')}

                <div className='mt-3'>
                    <Button type='secondary'
                            title={!enabled || submitted ? pageTranslates.PendingDesc : pageTranslates.Submit}
                            disabled={!enabled || submitted}
                            full loading={submitLoading}
                            onClick={this.submit}/>

                    {!enabled &&
                    <Button type='primary'
                            title={pageTranslates.Edit}
                             full
                            onClick={()=>this.setState({enabled: true})}/>
                    }
                </div>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(CourseRegistration);

